/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A custom header to be used for authentication. Automatically added by the backend.
 * @export
 * @interface CustomAuthHeader
 */
export interface CustomAuthHeader {
    /**
     * The name of the header.
     * @type {string}
     * @memberof CustomAuthHeader
     */
    name: string;
    /**
     * The value of the header, represented as a Golang text/template expression. Only the backend will interpret this.
     * @type {string}
     * @memberof CustomAuthHeader
     */
    valueTemplate: string;
}

/**
 * Check if a given object implements the CustomAuthHeader interface.
 */
export function instanceOfCustomAuthHeader(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "valueTemplate" in value;

    return isInstance;
}

export function CustomAuthHeaderFromJSON(json: any): CustomAuthHeader {
    return CustomAuthHeaderFromJSONTyped(json, false);
}

export function CustomAuthHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAuthHeader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'valueTemplate': json['valueTemplate'],
    };
}

export function CustomAuthHeaderToJSON(value?: CustomAuthHeader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'valueTemplate': value.valueTemplate,
    };
}

